import React from 'react'
import PropTypes from 'prop-types'

const PlayIcon = ({
  width,
  height,
  color,
  withBorder,
  borderWidth,
  backgroundColor,
  pageName,
}) => (
  <span
    className={[
      'TriangleRightIcon',
      (withBorder || borderWidth) && 'border',
    ]
      .filter(Boolean)
      .join(' ')}
    style={{
      height,
      width,
    }}
  >
    <svg
      viewBox="0 0 7.5 10"
      width="42.5%"
      height="42.5%"
    >
      <polygon fill={color} points="0,0 8.5,5 0,10 0,0" />
    </svg>
    <style jsx>{`
      .TriangleRightIcon {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${backgroundColor};
      }
      .TriangleRightIcon.border {
        border-radius: 50%;
        border: ${borderWidth} solid ${color};
      }
      svg {
        margin-left: 7.5%;
      }
      @media (max-width: 767px) {
        .TriangleRightIcon {
          width: ${pageName === 'category' ? '24px !important' : ''};
          height:  ${pageName === 'category' ? '24px !important' : ''};
        }
      }
      @media (min-width:767px) and (max-width:1200px) {
        .TriangleRightIcon {
          width:  ${pageName === 'category' ? '32px !important' : ''};
          height:  ${pageName === 'category' ? '32px !important' : ''};
        }
      }
    `}
    </style>
  </span>
)

PlayIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  color: PropTypes.string,
  withBorder: PropTypes.bool,
  borderWidth: PropTypes.string,
  backgroundColor: PropTypes.string,
  pageName: PropTypes.string,
}

PlayIcon.defaultProps = {
  width: '3em',
  height: '3em',
  color: '#ffffff',
  withBorder: false,
  borderWidth: '3px',
  backgroundColor: 'transparent',
  pageName: '',
}

export default PlayIcon
